// @flow
export const Roles = {
  User: 'ROLE_USER',
  Beneficiary: 'ROLE_BENEFICIARY',
  Admin: 'ROLE_ADMIN',
  Manager: 'ROLE_RD',
  RIR: 'ROLE_RIR',
  RR: 'ROLE_RR',
  Support: 'ROLE_SUPPORT',
  AssistAdmin: 'ROLE_ASSIST_ADMIN',
  Coach: 'ROLE_CP',
};
